._container_whnqz_1 {
  display: flex;
  flex-grow: 1;
  overflow: hidden; }
